import { render, staticRenderFns } from "./SubidTransformOld.vue?vue&type=template&id=001ef78a&scoped=true"
import script from "./SubidTransformOld.vue?vue&type=script&lang=js"
export * from "./SubidTransformOld.vue?vue&type=script&lang=js"
import style0 from "./SubidTransformOld.vue?vue&type=style&index=0&id=001ef78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001ef78a",
  null
  
)

export default component.exports